<template>
  <div class="w-auto bg-gray-100 flex items-center justify-between px-2 py-1">
      <div class="text-xl text-center">{{this.timeAsString}}</div>
      <div class="flex flex-inline space-x-2">
        <button v-if="status === 'not_started'" @click="start" class="hover:text-gray-800 underline">Start timer</button>
        <button v-if="status === 'paused'" @click="start" class="hover:text-gray-800 underline">Resume</button>
        <button v-if="status === 'running'" @click="pause" class="hover:text-gray-800">Pause</button>
        <button @click="reset" class="hover:text-red-600" v-if="status=='paused'">Reset</button>
      </div>

  </div>
</template>
<script>
import commandsManager from 'general/CommandsManager'

export default {
  name: 'timer',
  data(){
    return {
      time: 0,
      status: 'not_started',
      intervalFunc: null,
    }
  },
  methods: {
    start(propagate = true){
      this.status = 'running'
      this.intervalFunc = setInterval(()=>{
        this.time++;
      },1000)
      if(propagate)
        commandsManager.sendAllCommand('timer_start');
    },
    pause(propagate = true){
      clearInterval(this.intervalFunc);
      this.status = 'paused'
      if(propagate)
        commandsManager.sendAllCommand('timer_pause');
    },
    reset(propagate = true){
      this.time = 0;
      this.pause();
      this.status = "not_started"
      if(propagate)
        commandsManager.sendAllCommand('timer_reset');
    }
  },
  computed:{
    timeAsString(){
      let minutes = parseInt(this.time / 60);
      let seconds = this.time % 60;
      return `${minutes}`.padStart(2,'0') +':'+`${seconds}`.padStart(2,'0')
    }
  },
  mounted(){
    commandsManager.registerNewCommand('timer_init', ({status, time}) => {
      this.time = time;
      this.status = status;
      if(this.status == 'running')
        this.start(false);
    })
    commandsManager.registerNewCommand('timer_start', ()=>{
      this.start(false);
    });
    commandsManager.registerNewCommand('timer_pause', ()=>{
      this.pause(false);
    });
    commandsManager.registerNewCommand('timer_reset', ()=> {
      this.reset(false)
    })
  }
}
</script>
